import React, { useEffect, useRef, useState } from 'react';

const PayPalButtonComponent = ({ payment, paypalid1, onPaymentSuccess }) => {
  const [payamount, setpayamount] = useState(payment);
  const [paypalid, setpaypalid] = useState(paypalid1);
  const paypalRef = useRef(null);

  useEffect(() => {
    setpayamount(payment);
    setpaypalid(paypalid1);
  }, [payment, paypalid1]);

  useEffect(() => {
    // Check if PayPal script is already loaded
    const loadPayPalScript = () => {
      if (document.getElementById('paypal-sdk')) return;  // Prevent loading the script again
      const script = document.createElement('script');
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=USD`;
      script.id = 'paypal-sdk';
      script.onload = () => initializePayPalButton();
      document.body.appendChild(script);
    };

    if (!window.paypal) {
      loadPayPalScript();
    } else {
      initializePayPalButton();
    }

    function initializePayPalButton() {
      if (paypalRef.current) {
        // Clear any existing PayPal button before re-rendering
        paypalRef.current.innerHTML = '';
        window.paypal.Buttons({
          createOrder: function (data, actions) {
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: payamount // Use dynamic amount
                },
                payee: {
                  email_address: paypalid // Set the seller's PayPal email address here
                }
              }]
            });
          },
          onApprove: function (data, actions) {
            return actions.order.capture().then(function (details) {
              alert('Transaction completed by ' + details.payer.name.given_name);
              if (onPaymentSuccess) {
                onPaymentSuccess(data.orderID);
              }
            });
          },
          onError: function (err) {
            console.error('PayPal Button Error:', err);
          }
        }).render(paypalRef.current); // Render PayPal button into the div
      }
    }

    // Cleanup on component unmount
    return () => {
      if (paypalRef.current) {
        paypalRef.current.innerHTML = '';
      }
    };
  }, [payamount, paypalid]); // Re-run effect when `payamount` or `paypalid` changes

  return (
    <div>
      <div ref={paypalRef}></div> {/* Use ref to track the PayPal button container */}
    </div>
  );
};

export default PayPalButtonComponent;
